export default "__VITE_ASSET__9808c178__"